import { render, staticRenderFns } from "./MetricsHistogram.vue?vue&type=template&id=0cab1152&scoped=true"
import script from "./MetricsHistogram.vue?vue&type=script&lang=ts"
export * from "./MetricsHistogram.vue?vue&type=script&lang=ts"
import style0 from "./MetricsHistogram.vue?vue&type=style&index=0&id=0cab1152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cab1152",
  null
  
)

export default component.exports